import React from 'react'

const About = () => {
  return (
    <div>
        <h2>This is About us Page</h2>
    </div>
  )
}

export default About